import AutocompleteArrayInputEx from "components/_extensions/react-admin/ra-ui-materialui/src/input/AutocompleteArrayInputEx";
import React from "react";
import { useGetList } from "react-admin";

const PLACES_PAGINATION = { page: 1, perPage: 25 };
const PLACES_SORT = { field: "id", order: "DESC" };

export const PlaceSelectArrayInput = ({ terminalId, filter, ...props }) => {
	const placesFilter = { ...filter, terminal_id: [terminalId], no_range: true };
	const { data, ids } = useGetList("areas", PLACES_PAGINATION, PLACES_SORT, placesFilter);
	const choices = (ids || []).map((id) => data[id]).filter(Boolean);

	return <AutocompleteArrayInputEx optionText="name" {...props} choices={choices} />;
};
